import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  cilBarChart,
  // cilBook,
  // cilCalendar,
  // cilChartLine,
  cilEducation,
  // cilGrain,
  cilHome,
  cilPencil,
  // cilPeople,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'

import { CNavItem, CNavTitle } from '@coreui/react-pro'

export const useNavigationByRole = (role) => {
  const { t } = useTranslation()

  const baseNavigation = {
    main: [
      {
        component: CNavItem,
        name: t('Home'),
        to: '/dashboard',
        icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
        type: 'menu',
      },
      {
        component: CNavTitle,
        name: t('Questions'),
        roles: ['student'],
        type: 'menu',
      },
      {
        component: CNavItem,
        name: t('Resolve questions'),
        to: '/questions',
        icon: <CIcon icon={cilPencil} customClassName="nav-icon" />,
        description: t('Practice individual questions to strengthen your knowledge.'),
        roles: ['student'],
      },
      // {
      //   component: CNavItem,
      //   name: t('My books'),
      //   to: '/my-books',
      //   icon: <CIcon icon={cilBook} customClassName="nav-icon" />,
      //   roles: ['student'],
      // },
      // {
      //   component: CNavItem,
      //   name: t('My questions'),
      //   to: '/questions',
      //   icon: <CIcon icon={cilBook} customClassName="nav-icon" />,
      //   description: t('View and manage the questions you’ve created.'),
      //   roles: ['author', 'teacher'],
      // },
      // {
      //   component: CNavItem,
      //   name: t('Questions'),
      //   to: '/questions',
      //   icon: <CIcon icon={cilBook} customClassName="nav-icon" />,
      //   description: t('Browse and manage all questions in the system.'),
      //   roles: ['owner', 'staff'],
      // },
      {
        component: CNavItem,
        name: t('Mock tests'),
        to: '/mock-tests',
        icon: <CIcon icon={cilEducation} customClassName="nav-icon" />,
        description: t('Simulate exams with real questions to test your performance.'),
        roles: ['student'],
      },
      // {
      //   component: CNavTitle,
      //   name: t('Study plans'),
      //   roles: ['student'],
      //   type: 'menu',
      // },
      // {
      //   component: CNavItem,
      //   name: t('My plans'),
      //   to: '/my-plans',
      //   icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
      //   roles: ['student'],
      // },
      // {
      //   component: CNavItem,
      //   name: t('My performance'),
      //   to: '/my-performance',
      //   icon: <CIcon icon={cilChartLine} customClassName="nav-icon" />,
      //   roles: ['student'],
      // },
      {
        component: CNavTitle,
        name: t('Management'),
        type: 'menu',
        roles: ['teacher', 'owner', 'supervisor', 'staff'],
      },
      {
        component: CNavItem,
        name: 'Simulados',
        to: '/manager/mock-tests',
        icon: <CIcon icon={cilEducation} customClassName="nav-icon" />,
        description: 'Crie e gerencie simulados para seus alunos.',
        roles: ['teacher'],
      },
      // {
      //   component: CNavItem,
      //   name: t('My students'),
      //   to: '/manager/students',
      //   icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
      //   description: t('Manage the students assigned to you.'),
      //   roles: ['teacher', 'supervisor'],
      // },
      // {
      //   component: CNavItem,
      //   name: t('Students'),
      //   to: '/manager/students',
      //   icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
      //   description: t('View and manage all registered students.'),
      //   roles: ['owner', 'staff'],
      // },
      // {
      //   component: CNavItem,
      //   name: t('My study groups'),
      //   to: '/manager/study-groups',
      //   icon: <CIcon icon={cilGrain} customClassName="nav-icon" />,
      //   description: t('Access and organize your study groups.'),
      //   roles: ['teacher', 'supervisor'],
      // },
      // {
      //   component: CNavItem,
      //   name: t('Staff members'),
      //   to: '/manager/members',
      //   icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
      //   description: t('Manage users with staff-level access.'),
      //   roles: ['owner'],
      // },
      // {
      //   component: CNavItem,
      //   name: t('Supervisors'),
      //   to: '/manager/supervisors',
      //   icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
      //   description: t('Manage and assign supervisor roles.'),
      //   roles: ['owner', 'staff'],
      // },
      // {
      //   component: CNavItem,
      //   name: t('Teachers'),
      //   to: '/manager/teachers',
      //   icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
      //   description: t('Manage teacher accounts and permissions.'),
      //   roles: ['owner', 'staff'],
      // },
      // {
      //   component: CNavItem,
      //   name: t('Authors'),
      //   to: '/manager/authors',
      //   icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
      //   description: t('Manage users who create educational content.'),
      //   roles: ['owner', 'staff'],
      // },
      // {
      //   component: CNavItem,
      //   name: t('Study groups'),
      //   to: '/manager/study-groups',
      //   icon: <CIcon icon={cilGrain} customClassName="nav-icon" />,
      //   description: t('Create and manage collaborative study groups.'),
      //   roles: ['owner', 'staff'],
      // },
      {
        component: CNavItem,
        name: t('Reports'),
        to: '/reports',
        icon: <CIcon icon={cilBarChart} customClassName="nav-icon" />,
        description: t('Access performance and activity reports.'),
        roles: ['student', 'teacher'],
      },
      // {
      //   component: CNavItem,
      //   name: t('Subscription'),
      //   to: '/subscription',
      //   icon: <CIcon icon={cilMoney} customClassName="nav-icon" />,
      //   roles: ['student'],
      // },
    ],
    bottom: [
      // {
      //   component: CNavItem,
      //   name: t('Profile'),
      //   to: '/profile',
      //   icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
      // },
    ],
  }

  const filterItems = (items) => {
    return items.filter((item) => !item.roles || item.roles.includes(role))
  }

  const shortcuts = () => {
    const filteredShortcuts = filterItems(baseNavigation.main)

    return filteredShortcuts.filter((item) => item.type !== 'menu')
  }

  const menuItems = {
    main: filterItems(baseNavigation.main),
    bottom: filterItems(baseNavigation.bottom),
  }

  return {
    shortcutsItems: shortcuts(),
    menuItems,
  }
}
